@if (!loading && !allProducts.length) {
  <div class="fui-header-hero products-page m-b-50 m-t-20">
    <div>
      <div class="d-flex justify-content-center m-b-20">
        <myp-svg id="fender-logo" class="svg-white" width="100" height="50" style="margin-right: 20px" />
        <myp-svg id="presonus-logo" class="svg-white" width="130" height="50" />
      </div>
      <div class="d-flex justify-content-center m-b-30 flex-wrap">
        <myp-svg id="jackson-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="charvel-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="evh-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="gretsch-logo" class="svg-white m-x-10" width="90" height="45" />
      </div>
      <fui-heading [text]="'my_gear.register_your_gear' | translate" color="white" textAlign="center" [level]="2" fontSize="f9"></fui-heading>
      <span class="text-center">{{ "my_gear.register_your_gear_description" | translate }}</span>
      <div>
        <button class="btn btn-secondary white m-t-30" (click)="registerClicked.next(true)">{{ "my_gear.register_your_gear_button" | translate }}</button>
        <button class="btn btn-blank m-t-30 c-white" (click)="appService.goToFenderShop()">
          {{ "my_gear.register_your_gear_button_fender" | translate }}
        </button>
      </div>
    </div>
  </div>
}

<div class="content-constrained">
  @if (!loading && allProducts.length && allProducts.length > 1) {
    <div class="col">
      <section role="region" aria-label="Product filter and list">
        <div class="sr-only">The following text field filters the product list as you type. Results will update automatically. Use the sort options to change the order of products.</div>

        <div class="fui-layout-pad-content">
          <fui-content-filter
            #fuiContentFilter
            [activeQuery]="filterQuery"
            [showSidebarToggle]="hasMoreThanOneCategory"
            (refineClicked)="showFilterOptions = !showFilterOptions"
            [resultsCount]="selectedCategory?.count || allProducts?.length || 0"
            (clearQuery)="filterQuery = ''; filterProducts('')"
            (sortChanged)="sortProducts()"
            (clearFilter)="clearFilter($event); filter()"
            (queryChanged)="filterQuery = $event; filterProducts($event)"
            (showMobileFiltersClicked)="appService.showModal(sidebarFilterModal, { size: 'lg' })"
          ></fui-content-filter>
        </div>

        <div class="sr-only" aria-live="assertive" role="status">{{ filterAnnouncement }}</div>
      </section>
    </div>
  }

  @if (!loading && allProducts.length) {
    <hr />
  }
  @if (loading) {
    <div class="product-list m-t-10">
      <myp-skeleton-loader class="grid-container pad-4" type="product-tile" number="19"></myp-skeleton-loader>
    </div>
  }
  @if (allProducts.length) {
    <div class="product-list position-relative refine-content">
      <div class="fui-sidebar-content-container">
        @if (showFilterOptions && hasMoreThanOneCategory) {
          <div class="fui-sidebar-filter sticky">
            <ng-container *ngTemplateOutlet="filterContent"></ng-container>
            <button class="small-btn m-t-30" (click)="fuiContentFilter.refine()">
              <fa-icon icon="times"></fa-icon>
              Done
            </button>
          </div>
        }
        @if (appService.prefersGrid) {
          <div class="grid-container pad-4">
            <myp-product-tile (registerProductClicked)="registerClicked.next(true)" class="register-product-tile" [registerProductTile]="true"></myp-product-tile>
            @if (productService.simpleProductList) {
              @for (prod of displayedProducts; track prod) {
                @if (!prod.filtered) {
                  <myp-product-tile (tileClicked)="go(prod)" [product]="prod"></myp-product-tile>
                }
              }
            }
          </div>
        }
        @if (!appService.prefersGrid) {
          <div class="fui-layout-pad-content m-t-30" [class.fui-sidebar-shown]="showFilterOptions">
            @for (prod of displayedProducts; track prod) {
              @if (!prod.filtered) {
                <myp-list-item
                  [title]="prod.title"
                  [photo]="prod.imageUrl"
                  [showBackground]="true"
                  [showUnreadBadge]="userService.userMetadataLoaded && (!userService.userMetadata.products_seen || !userService.userMetadata.products_seen[prod.id])"
                  [metadata]="[
                    {
                      title: 'Registered',
                      value: prod.aquired || prod.releaseDate | date,
                    },
                  ]"
                  marginBottom="10px"
                  (itemClicked)="go($event)"
                  [imageRound]="false"
                  [item]="prod"
                >
                  <div class="button-content">
                    @if (prod && prod.categoryId == "software") {
                      <button
                        class="m-r-10 fa-button"
                        (keyup.enter)="downloadInstaller(prod); $event.stopPropagation()"
                        (click)="downloadInstaller(prod); $event.stopPropagation()"
                        [ngbTooltip]="'products.download_installer' | translate"
                        placement="top"
                        tooltipClass="nowrap"
                      >
                        <fa-icon aria-label="Download" icon="download"></fa-icon>
                      </button>
                    }
                    @if (prod && prod.featuredSample) {
                      <button
                        class="m-r-10 fa-button"
                        (keyup.enter)="playSample(prod, $event); $event.stopPropagation()"
                        (click)="playSample(prod, $event); $event.stopPropagation()"
                        [ngbTooltip]="'Play Sample'"
                        placement="top"
                        tooltipClass="nowrap"
                      >
                        <fa-icon aria-label="Play Sample" icon="play-circle"></fa-icon>
                      </button>
                    }
                  </div>
                </myp-list-item>
              }
            }
          </div>
        }
      </div>
    </div>
  }

  @if (allProducts.length) {
    <div style="height: 20px"></div>
  }
</div>

<!-- Reusable filter content template -->
<ng-template #filterContent>
  <!-- <div class="fui-sidebar-search">
  <input type="text" placeholder="Search" [(ngModel)]="filterQuery" (keyup)="filterProducts(filterQuery)" />
</div> -->
  <ul>
    @for (cat of productService.productCategories; track cat) {
      @if (cat.count) {
        <li class="fui-primary-category" [class.selected]="selectedCategory?.string_id == cat.string_id">
          <a (click)="selectProductCategory(cat)" (keyup.enter)="selectProductCategory(cat)" (keyup.space)="selectProductCategory(cat)">
            {{ cat.languages[helperService.selectedLanguage.code] }}
            <span class="fui-filter-badge">
              <span class="sr-only">total count</span>
              ({{ cat.count }})
            </span>
          </a>
          @if (cat.children?.length) {
            <ul class="fui-secondary-categories">
              @for (subcat of cat.children; track subcat) {
                @if (subcat.count) {
                  <li class="fui-secondary-category d-block" [class.selected]="selectedCategory?.string_id == subcat.string_id">
                    <a (keyup.enter)="selectProductCategory(subcat)" (keyup.space)="selectProductCategory(subcat)" (click)="selectProductCategory(subcat)">
                      {{ subcat.languages[helperService.selectedLanguage.code] }}
                      <span class="list-item-badge">
                        <span class="sr-only">total count</span>
                        ({{ subcat.count }})
                      </span>
                    </a>
                  </li>
                }
              }
            </ul>
          }
        </li>
      }
    }
  </ul>
</ng-template>

<!-- Modal template for mobile filter -->
<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="modal.close()">Done</button>
  </div>
</ng-template>
